;(function($, window, undefined){
	"use strict";

	function addClassesOnContent(){
		/* Find `Connect with Us` block at
		 * end of the_content() */
		$('.wysiwyg ul').last().addClass('wysiwyg-connect');

		/* Find `title like` elements and
		 * make them headings */
		$('.wysiwyg > p > strong').each(function(){
			var $el = $(this);
			$el.parent().replaceWith('<h3>'+$el.text()+'</h3>');
		});

	}

	if (window.SITE.isPage('single-post')){
		
		init();
	}

	function init(){
		// move subscribe buttons under the player
		$('.player_container').after($('.podcast-btns--top'));

		addClassesOnContent();
	};


})(jQuery, window);